import React from 'react'

const testimonials = [
  {
    name: 'Maria Johanna',
    city: 'Halle',
    body: (
      <>
        Anfangs war ich skeptisch. Aber der Ablauf war kinderleicht und ging schneller als gedacht! Au&szlig;erdem gab es
        f&uuml;r mein Fahrzeug mehr als bei einem anderen Anbieter. Auch deshalb wirklich empfehlenswert.
      </>
    ),
  },
  {
    name: 'Oliver M&uuml;ller',
    city: 'Berlin',
    body: (
      <>
        Toll. Einfach top durchorganisiert. Das merkt man vom ersten Augenblick an. In 20 Minuten war ich durch und nicht
        mal 48 Stunden nach der Online-Bewertung meines SUVs hatte ich mein Geld!
      </>
    ),
  },
  {
    name: 'Silvia Phillips',
    city: 'Bautzen',
    body: (
      <>
        Wir wollten eigentlich unseren Wagen beim Kauf unseres neuen Wagens in Zahlung geben. Als wir aber h&ouml;rten, was
        uns der H&auml;ndler noch daf&uuml;r geben wollte, lie&szlig;en wir unseren Wagen bei{' '}
        <span className="text-brand-fuchsia">autoverkaufen.de</span> online bewerten und bekamen hier fast 2.000 Euro mehr
        daf&uuml;r. Wir haben keine Sekunde gez&ouml;gert.
      </>
    ),
  },
  {
    name: 'Steffen Ott',
    city: 'Bautzen',
    body: (
      <>
        Wurde mir von einem Kumpel empfohlen. Die meisten anderen wollten mich nur abgezocken. Hier hab ich am Ende sogar
        mehr als den Sch&auml;tzpreis bekommen.
      </>
    ),
  },
]

const TestimonialsSection = () => (
  <section className="container relative px-5 py-5 mx-auto leading-6 text-gray-800 lg:py-16">
    <div className="text-3xl font-bold leading-loose text-center text-gray-700 whitespace-normal">
      Das sagen unsere Kunden
    </div>
    <div className="relative grid grid-cols-2 md:grid-cols-4 gap-52" data-toggle="testimonials-glider">
      {testimonials.map(({ name, city, body }) => (
        <div className="flex flex-col p-6" key={`${name}-${city}`}>
          <p className="flex-grow">{body}</p>
          <div className="box-border mt-8 mb-2 text-gray-800 border border-gray-700 border-solid" style={{ width: '36%' }}></div>
          <div className="text-sm font-bold leading-5">
            {name}
            <br />
            <span className="text-blue-500">{city}</span>
          </div>
        </div>
      ))}
    </div>
  </section>
)

export default TestimonialsSection
